import { css, jsx } from '@emotion/react';
import { IconButton } from '../../navigation/IconButton/IconButton.es.js';

const Styles = {
  root: css`
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
  `
};
const DateRangePickerNavbar = ({ onNextClick, onPreviousClick }) => {
  return jsx(
    "div",
    { css: Styles.root, "data-zds": true },
    jsx(IconButton, { icon: "arrowSmallLeft", label: "Previous Month", onClick: () => onPreviousClick(), shouldCorrectTooltipPosition: false, tooltipPosition: "southwest", color: "icon-tertiary" }),
    jsx(IconButton, { icon: "arrowSmallRight", label: "Next Month", onClick: () => onNextClick(), shouldCorrectTooltipPosition: false, tooltipPosition: "southeast", color: "icon-tertiary" })
  );
};

export { DateRangePickerNavbar };
//# sourceMappingURL=DateRangePickerNavbar.es.js.map
